export class Response {
  protected data: any;

  constructor(responseJson?: any) {
    this.fromData(responseJson);
  }

  toData(): any {
    return this.data;
  }

  fromData(data: any) {
    this.data = data;
  }
}
